module.exports = __webpack_public_path__ + "static/media/cross.537a5371.svg";